import { useAuth } from "~/auth/useAuth";
import { useEasel } from "~/components/canvas/easel/useEasel";

import { ActiveUsers } from "./ActiveUsers";
import { CloneButton } from "./CloneButton";
import { PublishDocumentButton } from "./ShareDocument";
import { ToggleComponentsPaneButton } from "./ToggleComponentsPaneButton";

export const CanvasTopBarContent = () => {
	const { canvasWritable } = useEasel();
	const { isAuthenticatedOrLocal, isLocalApp } = useAuth();

	return (
		<>
			{/* Active Users */}
			{false && isAuthenticatedOrLocal && <ActiveUsers />}

			{!canvasWritable && isLocalApp && <CloneButton />}

			{/* show if unauthenticated so people know there is value in logging in */}
			{canvasWritable && isLocalApp && <PublishDocumentButton />}

			{isLocalApp && canvasWritable && <ToggleComponentsPaneButton />}
		</>
	);
};
